// We need to use window.fetch for NR to track the fetch calls
// To avoid native fetch without NR wrap being cached on clients that are singleton,
// we need to use a function that returns window.fetch
export default async (...args: [RequestInfo, RequestInit?]) => window.fetch(...args)
